/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PointsInputs */

const th_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แต้ม`)
};

const en_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PTS`)
};

const ja_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点`)
};

const zh_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分`)
};

const es_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PTS`)
};

const pt_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PTS`)
};

const id_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POIN`)
};

const fr_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PTS`)
};

const tl_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUNTOS`)
};

const vi_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐIỂM`)
};

const ko_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승점`)
};

const de_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PKT`)
};

const ru_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОЧК`)
};

const tr_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUAN`)
};

const it_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUNTI`)
};

const pl_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PKT`)
};

const uk_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОЧК`)
};

const hi_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक`)
};

const ar_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقاط`)
};

const ms_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MATA`)
};

const bn_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পয়েন্ট`)
};

const zh_tw2_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分`)
};

const zh_hk2_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分`)
};

const ur_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوائنٹ`)
};

const fa_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امتیاز`)
};

const sw_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POINTI`)
};

const nl_col_points = /** @type {(inputs: Col_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNT`)
};

/**
* | output |
* | --- |
* | "PTS" |
*
* @param {Col_PointsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const col_points = /** @type {((inputs?: Col_PointsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PointsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_col_points(inputs)
	if (locale === "ja") return ja_col_points(inputs)
	if (locale === "zh") return zh_col_points(inputs)
	if (locale === "es") return es_col_points(inputs)
	if (locale === "pt") return pt_col_points(inputs)
	if (locale === "id") return id_col_points(inputs)
	if (locale === "fr") return fr_col_points(inputs)
	if (locale === "tl") return tl_col_points(inputs)
	if (locale === "vi") return vi_col_points(inputs)
	if (locale === "ko") return ko_col_points(inputs)
	if (locale === "de") return de_col_points(inputs)
	if (locale === "ru") return ru_col_points(inputs)
	if (locale === "tr") return tr_col_points(inputs)
	if (locale === "it") return it_col_points(inputs)
	if (locale === "pl") return pl_col_points(inputs)
	if (locale === "uk") return uk_col_points(inputs)
	if (locale === "hi") return hi_col_points(inputs)
	if (locale === "ar") return ar_col_points(inputs)
	if (locale === "ms") return ms_col_points(inputs)
	if (locale === "bn") return bn_col_points(inputs)
	if (locale === "zh-TW") return zh_tw2_col_points(inputs)
	if (locale === "zh-HK") return zh_hk2_col_points(inputs)
	if (locale === "ur") return ur_col_points(inputs)
	if (locale === "fa") return fa_col_points(inputs)
	if (locale === "sw") return sw_col_points(inputs)
	if (locale === "nl") return nl_col_points(inputs)
	return en_col_points(inputs)
});